import styled from 'styled-components';

export const Application = styled.div`
    position: relative;
`